import MainPage from "./pages/MainPage";
import ActiveWordContext from "./context/ActiveWordContext";
import EndOfVotingTimeContext from "./context/EndOfVotingTimeContext";
import StoryContext from "./context/StoryContext";
import AlreadyVotedContext from "./context/AlreadyVotedContext";
import React, { useEffect, useState } from "react";
import ErrorMessagesContext from "./context/ServerIsDownContext";
import ServerIsDownMessage from "./components/ServerIsDownMessage";
import { getStoryEndpoint } from "./api/endpoints.js";
import Toaster from "./components/Toaster";
import Layout from "./components/layout/Layout";
import "./App.module.scss";
import { Route, Routes } from "react-router-dom";
import CurrentVotingPage from "./pages/CurrentVotingPage";
import NoMatch from "./pages/NoMatch";
import PastVotingPage from "./pages/PastVotingPage";
import VotingPage from "./pages/VotingPage";

function App() {
  const [activeWordId, setActiveWordId] = useState(-1);
  const activeWordContextValue = { activeWordId, setActiveWordId };

  const [endOfVotingTime, setEndOfVotingTime] = useState(null);
  const endOfVotingTimeContextValue = { endOfVotingTime, setEndOfVotingTime };

  const [currentStory, setCurrentStory] = useState([]);

  const [alreadyVoted, setAlreadyVoted] = useState(false);
  const alreadyVotedContextValue = { alreadyVoted, setAlreadyVoted };

  const [serverIsDown, setServerIsDown] = useState(false);
  const serverIsDownContextValue = { serverIsDown, setServerIsDown };

  useEffect(() => {
    let timer = null;
    function fetchData() {
      const url = getStoryEndpoint();
      fetch(url)
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          setCurrentStory(data.story);
          setEndOfVotingTime({
            timeTillNextVoting: data.nextVoting,
            updateTime: Date.now(),
          });
          setAlreadyVoted(false);
          return data;
        })
        .then((data) => {
          timer = setTimeout(() => fetchData(), data.nextVoting);
        })
        .catch((err) => {
          console.log(err);
          setServerIsDown(true);
        });
    }
    fetchData();
    return () => clearInterval(timer);
  }, []);

  return (
    <ErrorMessagesContext.Provider value={serverIsDownContextValue}>
      <ActiveWordContext.Provider value={activeWordContextValue}>
        <EndOfVotingTimeContext.Provider value={endOfVotingTimeContextValue}>
          <StoryContext.Provider value={currentStory}>
            <AlreadyVotedContext.Provider value={alreadyVotedContextValue}>
              {Toaster}
              {serverIsDown && <ServerIsDownMessage />}
              <Routes>
                <Route path="/" element={<Layout />}>
                  <Route index element={<MainPage />} />
                  <Route path="vote" element={<VotingPage />}>
                    <Route index element={<CurrentVotingPage />} />
                    <Route path=":votingId" element={<PastVotingPage />} />
                  </Route>
                  <Route path="*" element={<NoMatch />} />
                </Route>
              </Routes>
            </AlreadyVotedContext.Provider>
          </StoryContext.Provider>
        </EndOfVotingTimeContext.Provider>
      </ActiveWordContext.Provider>
    </ErrorMessagesContext.Provider>
  );
}

export default App;
